import script from "./StripeConnectRedirect.vue?vue&type=script&setup=true&lang=js"
export * from "./StripeConnectRedirect.vue?vue&type=script&setup=true&lang=js"

import "./StripeConnectRedirect.vue?vue&type=style&index=0&id=5b130da0&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b130da0"]])

export default __exports__